import { FC } from 'react'
import ReactPaginate from 'react-paginate'
import { IUserHistoryItem } from '../../api/logs.types'
import { Table } from '../../../../../components/Table'
import { TableHead } from '../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../components/Table/TableBody'
import { convertUTCtoMSK } from '../../../../../utils'
import { AppSelect } from '../../../../../components/Select'
import { USER_EVENT_OPTIONS, userEventLabel } from './userEvents'

type Props = {
  events: IUserHistoryItem[]
  loading: boolean
  /** The page being shown, from 1 — the pager follows it, so a filter reset returns it to the first page. */
  page: number
  pageCount: number
  onPageChange: (page: number) => void
  /** The event the log is narrowed to; null — every event. Without the handler the filter is not shown. */
  eventType?: string | null
  onEventTypeChange?: (eventType: string | null) => void
}

const COLUMNS = 4

/** What was done to accounts: creation, blocking, the second factor, password changes. */
export const UserEventsTable: FC<Props> = ({ events, loading, page, pageCount, onPageChange, eventType = null, onEventTypeChange }) => (
  <div className='d-flex flex-column'>
    {onEventTypeChange && (
      <div className='mb-4' style={{ maxWidth: 420 }}>
        <AppSelect
          options={USER_EVENT_OPTIONS}
          value={USER_EVENT_OPTIONS.find((option) => option.value === eventType) ?? null}
          onChange={(option: { value: string } | null) => onEventTypeChange(option?.value ?? null)}
          isClearable
          placeholder='Событие: все'
          noOptionsMessage={() => 'Нет вариантов'}
        />
      </div>
    )}
    <Table>
      <TableHead>
        <tr>
          <th>Дата</th>
          <th>Кто</th>
          <th>Учётная запись</th>
          <th>Событие</th>
        </tr>
      </TableHead>
      <TableBody>
        {loading ? (
          <tr>
            <td colSpan={COLUMNS}>Идет загрузка...</td>
          </tr>
        ) : events.length ? (
          events.map((event, index) => (
            <tr key={index}>
              <td>{event.createdAt ? convertUTCtoMSK(event.createdAt) : '—'}</td>
              <td>{event.subject?.uuid ?? '—'}</td>
              <td>{event.object?.uuid ?? '—'}</td>
              <td>{userEventLabel(event)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={COLUMNS}>Данных нет.</td>
          </tr>
        )}
      </TableBody>
    </Table>

    <ReactPaginate
      activeClassName={'active-pagination '}
      breakClassName={'item-pagination break-me-pagination '}
      containerClassName={'pagination-pagination'}
      disabledClassName={'disabled-page-pagination'}
      nextClassName={'item-pagination ki-duotone ki-right fs-2x'}
      pageClassName={'item-pagination pagination-page-pagination '}
      previousClassName={'item-pagination ki-duotone ki-left fs-2x'}
      breakLabel='...'
      nextLabel=''
      onPageChange={(pageNumber) => onPageChange(pageNumber.selected + 1)}
      pageRangeDisplayed={5}
      pageCount={pageCount}
      forcePage={pageCount > 0 ? Math.min(page, pageCount) - 1 : undefined}
      previousLabel=''
      renderOnZeroPageCount={null}
    />
  </div>
)
